import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { IAddress } from './address.service';
import { Observable } from 'rxjs';
import { SettingService } from './setting.service';
import { finalize } from 'rxjs/operators';
import { IGeopoint } from 'src/app/store/pages/list-page/list-page.component';
import { ApiControllerService } from './api-controller.service';

@Injectable({
  providedIn: 'root'
})
export class GoogleApiService {
  constructor(private http: HttpClient,
    private setting: SettingService,
    private apiController: ApiControllerService) {

  }

  getAddressGeometry(address: IAddress): Observable<any> {
    return Observable.create(o => {
      /* this.http.get(this.setting.getGoogleApiUrl('maps/api/geocode/json'),
        {
          params: {
            'key': this.setting.getGoogleApiKey(),
            'address': `${address.streetNumber} ${address.street} ${address.city} ${address.province}`
          }
        })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe((result: any) => {
          o.next(result.results[0].geometry.location);
        }); */

        this.apiController.get(this.setting.getGoogleApiUrl('maps/api/geocode/json'),
          {
            params: {
              'key': this.setting.getGoogleApiKey(),
              'address': `${address.streetNumber} ${address.street} ${address.city} ${address.province}`
            }
          })
          .pipe(finalize(() => {
            o.complete();
          }))
          .subscribe((result: any) => {
            o.next(result.results[0].geometry.location);
          });
    });
  }

  getCountry(geopoint: IGeopoint): Observable<any> {
    return Observable.create(o => {
      /* this.http.get(this.setting.getGoogleApiUrl('maps/api/geocode/json'),
        {
          params: {
            'key': this.setting.getGoogleApiKey(),
            'latlng': `${geopoint.latitude}, ${geopoint.longitude}`
          }
        })
        .pipe(finalize(() => {
          o.complete();
        }))
        .subscribe((result: any) => {
          // get short name of country of address (geopoint)
          o.next(result.results[0].address_components[result.results[0].address_components.length - 2].short_name);
        }); */

        this.apiController.get(this.setting.getGoogleApiUrl('maps/api/geocode/json'),
          {
            params: {
              'key': this.setting.getGoogleApiKey(),
              'latlng': `${geopoint.latitude}, ${geopoint.longitude}`
            }
          })
          .pipe(finalize(() => {
            o.complete();
          }))
          .subscribe((result: any) => {
            // get short name of country of address (geopoint)
            o.next(result.results[0].address_components[result.results[0].address_components.length - 2].short_name);
          });
    });
  }
}
